"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueType = void 0;
var ValueType;
(function (ValueType) {
    ValueType["PERCENT"] = "PERCENT";
    ValueType["FRACTION"] = "FRACTION";
    ValueType["DOLLAR"] = "DOLLAR";
    ValueType["CENTS"] = "CENTS";
    ValueType["TEXT"] = "TEXT";
})(ValueType || (exports.ValueType = ValueType = {}));
